module.exports = "<div class=\"form-group row\">\r\n    <ixs-label label=\"{{label}}\"></ixs-label>\r\n    <div class=\"col-md-9\">\r\n        <div class=\"checkbox\">\r\n            <input type=\"checkbox\">\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkbox/checkbox.component.html
// module id = 1040
// module chunks = 22